export default "__VITE_ASSET__CV710sj3__"